let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5wMyt")).then(() => parcelRequire('hh8kS'));